import { Typography } from "@suraasa/placebo-ui"
import { useQuery } from "@tanstack/react-query"
import api from "api"
import CPATLogo from "features/Cpat/assets/cpat-mini-logo.png"
import CPATProctoringInstructions from "features/Cpat/CpatOverview/CpatProctoringInstruction"
import React from "react"
import { browserIsSupportedForProctoring, cpatType } from "utils/constants"
import { useEnrollments } from "utils/hooks/useEnrollments"
import useHideGlobalBottomNavigation from "utils/hooks/useGlobalHideBottomNavigation"
import useHideTopNavigation from "utils/hooks/useHideTopNavigation"

import { triggerFullscreen } from "../../helpers"
import UnsupportedBrowserDialog from "../../Instructions/SystemRequirement/UnsupportedBrowserDialog"
import AttemptCpatAssessment from ".."
import DurationTimer from "../DurationTimer"

const CpatAssessmentWrapper = () => {
  useHideGlobalBottomNavigation()
  useHideTopNavigation()

  const isProctored =
    new URLSearchParams(window.location.search).get("p") === "true"
  const [showInstructions, setShowInstructions] = React.useState(isProctored)

  const { enrollments } = useEnrollments()

  const cpats = enrollments
    ?.sort(
      (a, b) =>
        new Date(b.assignedAt).getTime() - new Date(a.assignedAt).getTime()
    )
    .filter(enrollment => enrollment.type === cpatType)

  const assessmentId = cpats?.[0]?.id

  const cpat = useQuery({
    queryKey: ["cpat-assessment", assessmentId],
    queryFn: () =>
      api.cpat.getAssessment({ params: { assessmentId: assessmentId } }),
    enabled: !!assessmentId,
  })

  const startTime = cpat.data?.assessment.startTime
  const endTime = cpat.data?.assessment.endTime

  const currentTime = new Date().toISOString()

  if (startTime && currentTime < startTime) {
    return (
      <div className="flex h-screen flex-col items-center justify-center">
        <img src={CPATLogo} alt="cpat logo" width={80} />
        <span className="mt-2 flex items-center text-largeBody">
          <Typography className="me-0.5" variant="title2">
            Assessment will start in{" "}
            <DurationTimer
              onEnd={() => window.location.reload()}
              toDate={startTime}
            />
          </Typography>
        </span>
      </div>
    )
  }

  if (endTime && currentTime > endTime) {
    return (
      <div className="flex h-screen flex-col items-center justify-center">
        <img src={CPATLogo} alt="cpat logo" width={80} />
        <span className="mt-2 flex items-center text-largeBody">
          <Typography className="me-0.5" variant="title2">
            The time window to attempt this assessment has ended
          </Typography>
        </span>
      </div>
    )
  }

  if (!isProctored) return <AttemptCpatAssessment />

  if (!showInstructions && browserIsSupportedForProctoring === "supported")
    return <AttemptCpatAssessment />

  if (showInstructions) {
    return (
      <CPATProctoringInstructions
        onProceed={() => {
          setShowInstructions(false)
          triggerFullscreen()
        }}
      />
    )
  }

  return <UnsupportedBrowserDialog open />
}

export default CpatAssessmentWrapper
